export const companyResourceUrl = 'companies';
